import '@/plugins/vue-composition-api'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import { app } from './plugins/firebase'
import axios from './utils/axios'

//導引
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)





Vue.config.productionTip = false

// PWA: 每次啟動時註冊 SW 並檢查更新，有新版本時自動重新載入
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/sw.js').then(function (registration) {
      // 定期檢查更新（每 60 秒）
      setInterval(function () {
        registration.update();
      }, 60 * 1000);

      // 偵測到新 SW 安裝完成時，重新載入頁面
      registration.addEventListener('updatefound', function () {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', function () {
            if (newWorker.state === 'activated' && navigator.serviceWorker.controller) {
              // 新版本已啟用，重新載入以使用最新前端
              window.location.reload();
            }
          });
        }
      });
    });
  });
}

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('HTwater.token');

  if (!token && !to.meta?.requiresAuth) {
    return next()
  }

  if (token) {
    if (to.name === 'pages-login') {
      return next('/calendar')
    }
    axios.get('/verify')
      .then((res) => {
        const { status } = res.data
        if (status === 200) {
          return next()
        } else {
          localStorage.removeItem('HTwater.token');
          next('/pages/login')
        }
      })
  } else {
    next('/pages/login')
  }
});


new Vue({
  router,
  store,
  vuetify,
  app,
  render: h => h(App),
}).$mount('#app')
